import uniq from 'lodash/uniq'

import { Domain, getRepository } from '@things-factory/shell'
import { analyzeIntegration } from '@things-factory/integration-base'
import { Board } from '../../service/board/board.js'

function findObjectsWithCondition(container, condition: (component: any) => boolean) {
  let result = []

  if (condition(container)) {
    result.push(container)
  }

  if (container.components) {
    for (const component of container.components) {
      result = result.concat(findObjectsWithCondition(component, condition))
    }
  }

  return result
}

function getRelationsInBoard(board: Board) {
  try {
    const model = JSON.parse(board.model) || {}

    const scenarioNames = findObjectsWithCondition(model, component => component.scenarioName).map(
      component => component.scenarioName
    )

    const tags = findObjectsWithCondition(model, component => component.tag).map(component => component.tag)

    return {
      scenarioNames: uniq(scenarioNames.filter(Boolean)),
      tags: uniq(tags.filter(Boolean))
    }
  } catch (err) {
    console.error('analyze-integration::getRelationsInBoard error', err)
    return {
      scenarioNames: [],
      tags: []
    }
  }
}

export async function analyzeBoardIntegration(domain: Domain) {
  const model = await analyzeIntegration(domain)

  var id = 0

  const boards = await getRepository(Board).find({
    where: { domain: { id: domain.id } }
  })

  model.nodes = model.nodes.concat(
    boards.map(board => {
      return {
        id: board.id,
        labels: ['Board'],
        text: board.name,
        icon: 'dashboard',
        properties: {
          name: board.name,
          description: board.description
        }
      }
    })
  )

  boards.forEach(board => {
    const { scenarioNames, tags } = getRelationsInBoard(board)

    var scenarioNodes = scenarioNames.map(name =>
      model.nodes.find(node => node.labels.includes('Scenario') && node.properties?.name == name)
    )
    var tagNodes = tags.map(tag => model.nodes.find(node => node.labels.includes('Tag') && node.properties?.tag == tag))

    const missingScenarioNodes = scenarioNodes
      .filter(node => !node)
      .map((_, i) => scenarioNames[i])
      .map(missingScenario => {
        return {
          id: `missing-scenario-${missingScenario}`,
          labels: ['Scenario'],
          text: missingScenario,
          icon: 'settings',
          properties: {
            name: missingScenario,
            missing: true
          }
        }
      })

    model.nodes = model.nodes.concat(missingScenarioNodes)

    const missingTagNodes = tagNodes
      .filter(node => !node)
      .map((_, i) => tags[i])
      .map(missingTag => {
        return {
          id: `missing-tag-${missingTag}`,
          labels: ['Tag'],
          text: missingTag,
          icon: 'label',
          properties: {
            name: missingTag,
            missing: true
          }
        }
      })

    model.nodes = model.nodes.concat(missingTagNodes)

    tagNodes.filter(node => !node).map((_, i) => tags[i])

    var relationships = [...scenarioNodes.filter(Boolean), ...missingScenarioNodes].map(node => {
      return {
        id: `bsce-${++id}`,
        type: 'call',
        startNode: board.id,
        endNode: node.id,
        properties: {}
      }
    })

    model.relationships = model.relationships.concat(relationships)

    relationships = [...tagNodes.filter(Boolean), ...missingTagNodes].map(node => {
      return {
        id: `btag-${++id}`,
        type: 'subscribe',
        startNode: board.id,
        endNode: node.id,
        properties: {}
      }
    })

    model.relationships = model.relationships.concat(relationships)
  })

  return model
}
